import { Component, OnInit } from '@angular/core';
import { HaCaselistServiceService } from '../../services/HaCaseList.service';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-case-list',
  templateUrl: './ha-case-list.component.html',
  styleUrls: ['./ha-case-list.component.css']
})

export class HaCaseListComponent implements OnInit {
  element: HTMLElement;
  caseDataFiltered: any[];
  caseDataOriginal: any[];
  patientData: any[];
  doctors: any[];
  searchTerm: string = '';
  caseTypeValue;
  showOverlayCaseList: boolean;
  showCaseDivLoader: boolean;
  showPatientDivLoader: boolean;
  elementSlide: HTMLElement;
  assignedListShow: boolean;
  showCaseCodeLoad: boolean = false;
  searchTermCaseList: string = "";
  listView: boolean = false;
  elementIcd: HTMLElement;
  elementCpt: HTMLElement;
  elementPre: HTMLElement;
  elementProc: HTMLElement;
  elementMed: HTMLElement;
  elementVen: HTMLElement;
  elementMain: HTMLElement;
  currentListCase: any[];
  dataList: any[];
  currentSelectedId;
  mainViewError = new ErrorModel();
  patientError = new ErrorModel();


  constructor(private _service: HaCaselistServiceService) {

  }

  ngOnInit() {
    this.showOverlayCaseList = true;
    this.getCaseData();
  }

  getCaseData() {
    this.mainViewError.display = false;
    this.showOverlayCaseList = true;

    this._service.getCaseListData().subscribe(
    (data: any[]) => {
      this.caseDataFiltered = data["cases"];
      this.caseDataOriginal = data["cases"];
      this.doctors = data["doctors"];

    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayCaseList = false;
    });
  }


  onEventPropagation(data) {
    data.evt.stopPropagation();
    this.showCodes(data.id, data.type);
  }

  openNav(caseId) {
    for (let cases of this.caseDataFiltered) {
      cases.border = "2px solid #eee";
      cases.borderBottom = "2px solid #eee";
    }
    let index = this.caseDataFiltered.findIndex(a => a.id == caseId);
    this.caseDataFiltered[index].border = '2px solid #0969c9';
    this.caseDataFiltered[index].borderBottom = '2px solid #0969c9';
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = '0px';
    this.elementSlide.style.opacity = '1';
    this.showTemplate(caseId);
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = '70%';
  }

  closeNav() {
    for (let cases of this.caseDataFiltered) {
      cases.border = "";
      cases.borderBottom = "";
    }
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = "-105%";
    this.elementSlide.style.opacity = "0";
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = "100%";
  }

  //code to get list of patient assisgned to the selected case
  showTemplate(idValue) {
    this.currentSelectedId = idValue;
    this.patientError.display = false;
    this.showPatientDivLoader = true;
    this._service.getPatientByCase(idValue).subscribe(
    (data: any[]) => {
      this.patientData = data;
      this.assignedListShow = this.patientData.length <= 0 ? true : false;
    },
    (error) => {
      this.patientError.error = error;
      this.patientError.display = true;

    }).add(() => {
      this.showPatientDivLoader = false;

    });
  }

  //code to get and display the code associated with the selected case
  showCodes(idValue, caseValue) {
    this.showCaseCodeLoad = true;
    this.caseTypeValue = caseValue;
    this.dataList = [];
    $("#caseTypeName").modal('show');
    this._service.getCodesByCase(idValue).subscribe((data: any[]) => {
      this.dataList = data;
      this.changeDiv("1");
    });
  }

  //code to get list of cases associated based on doctor selected
  getFilteredList(event) {
    this.showCaseDivLoader = true;
    if (event == "") {
      this.caseDataFiltered = this.caseDataOriginal;
      this.showCaseDivLoader = false;
    } else {
      this.caseDataFiltered = this.caseDataOriginal.filter(i => i.docId == event);
      this.showCaseDivLoader = false;
    }
  }

  public activeElementCodecase = "1"

  changeDiv(index) {
    this.showCaseCodeLoad = true;
    this.elementIcd = document.getElementById("ICD_Div");
    this.elementCpt = document.getElementById("CPT_Div");
    this.elementPre = document.getElementById("Preop_Div");
    this.elementProc = document.getElementById("Proced_Div");
    this.elementMed = document.getElementById("medical_Div");
    this.elementVen = document.getElementById("vendor_Div");
    this.activeElementCodecase = index;
    this.elementIcd.style.display = index == "1" ? "block" : "none";
    this.elementCpt.style.display = index == "2" ? "block" : "none";
    this.elementMed.style.display = index == "3" ? "block" : "none";
    this.elementPre.style.display = index == "4" ? "block" : "none";
    this.elementProc.style.display = index == "5" ? "block" : "none";
    this.elementVen.style.display = index == "6" ? "block" : "none";
    this.currentListCase = [];
    switch (index) {
      case "1": {
        this.currentListCase = this.dataList["icdCodes"];
        break;
      }
      case "2": {
        this.currentListCase = this.dataList["cptCodes"];
        break;
      }
      case "3": {
        this.currentListCase = this.dataList["preopCodes"];
        break;
      }
      case "4": {
        this.currentListCase = this.dataList["procedures"];
        break;
      }
      case "5": {
        this.currentListCase = this.dataList["medDevices"];
        break;
      }
      case "6": {
        this.currentListCase = this.dataList["vendors"];
        break;
      }
      default: {
        this.currentListCase = [];
      }
    }
    this.showCaseCodeLoad = false;
  }

}
